<template>
<el-row type="flex" justify="center">
	<el-col :xs="24" :sm="12" :md="10" :lg="8">
		<el-form label-position="top" label-width="200px">
			<h1>New Entry</h1>
			<hr>
			<el-form-item label="Refuelled at:">
				<el-date-picker placeholder="Please enter the date and time of this refuel" :disabled="app.isLoading" type="datetime" v-model="local.refueled_at" format="dd/MM/yyyy HH:mm" :clearable="false"></el-date-picker>
			</el-form-item>

			<el-form-item label="Refuelling Amount (KG):">
				<el-input placeholder="Please enter in KGs" v-model="local.refuelling_amount" @input="$v.local.refuelling_amount.$touch()" :disabled="app.isLoading">
				</el-input>
				<div v-if="$v.local.refuelling_amount.$error">
					<div class="el-form-item__error">
						<span v-if="!$v.local.refuelling_amount.decimal">Please enter a valid number.</span>
						<span v-if="!$v.local.refuelling_amount.required">Field is required.</span>
						<span v-if="!$v.local.refuelling_amount.maxLength">This value is too large.</span>
					</div>
				</div>
			</el-form-item>

			<el-form-item v-if="app.user.vehicle_model === 'Symbio'" label="Electricity Amount (kWh):">
				<el-input placeholder="Please enter in kWh" :disabled="app.isLoading" @input="$v.local.electricity_amount.$touch()" v-model="local.electricity_amount"></el-input>
				<div v-if="$v.local.electricity_amount.$error">
					<div class="el-form-item__error">
						<span v-if="!$v.local.electricity_amount.decimal">Please enter a valid number.</span>
						<span v-if="!$v.local.electricity_amount.required">Field is required.</span>
						<span v-if="!$v.local.electricity_amount.maxLength">This value is too large.</span>
					</div>
				</div>
			</el-form-item>

			<el-form-item :label="'Odometer Reading (' + app.user.units + '):'">
				<el-input :placeholder="'Please enter your odometer reading in ' + app.user.units" @input="$v.local.odometer_reading.$touch()" :disabled="app.isLoading" v-model="local.odometer_reading"></el-input>
				<div v-if="$v.local.odometer_reading.$error">
					<div class="el-form-item__error">
						<span v-if="!$v.local.odometer_reading.numeric">Please enter a valid number.</span>
						<span v-if="!$v.local.odometer_reading.required">Field is required.</span>
					</div>
				</div>
			</el-form-item>

			<el-form-item :label="'Price (' + app.loadCurrencySymbol(app.user.currency) + '):'">
				<el-input :placeholder="'Optional: Please enter a price in ' + app.loadCurrencySymbol(app.user.currency)" @input="$v.local.price.$touch()" :disabled="app.isLoading" v-model="local.price"></el-input>
				<div v-if="$v.local.price.$error">
					<div class="el-form-item__error">
						<span v-if="!$v.local.price.decimal">Please enter a valid number.</span>
						<span v-if="!$v.local.price.maxLength">This value is too large.</span>
					</div>
				</div>
			</el-form-item>

			<el-form-item label="Station Location: ">
				<el-input placeholder="Optional: Please enter the refuelling location" :disabled="app.isLoading " v-model.trim="local.refuelling_station_location "></el-input>
			</el-form-item>

			<el-form-item label="Notes: ">
				<el-input placeholder="Optional: Please enter any additional notes about this refuel" type="textarea" autosize v-model.trim="local.notes ">
				</el-input>
			</el-form-item>
			<hr>
			<p>
				<el-button type="primary" @click="addEntry " :disabled="$v.$invalid || app.isLoading " :loading="app.isLoading ">Add Entry</el-button>
			</p>
		</el-form>
	</el-col>
</el-row>
</template>

<script>
import {
	alphaNum,
	required,
	requiredIf,
	maxLength
} from "vuelidate/lib/validators";
import axios from "axios";
import * as auth from "@/utils/auth";
import router from "@/router";
import store from "@/utils/store";
import {
	assign
} from "lodash";
import {
	USER_URL,
	INPUT_URL
} from "@/config";
import {
	decimal,
	numeric
} from "@/utils/validators";
export default {
	name: "dashboard",
	data() {
		return {
			app: store,
			local: {
				refuelling_amount: "",
				odometer_reading: "",
				price: "",
				refueled_at: new Date(),
				refuelling_station_location: "",
				electricity_amount: store.user.vehicle_model === "Symbio" ? null : 0,
				notes: ""
			}
		};
	},
	validations: {
		local: {
			refuelling_amount: {
				required,
				decimal,
				maxLength: maxLength(8)
			},
			electricity_amount: {
				required: requiredIf(
					() => store.user.vehicle_model === "Symbio"
				),
				decimal,
				maxLength: maxLength(8)
			},
			odometer_reading: {
				required,
				numeric
			},
			price: {
				decimal,
				maxLength: maxLength(6)
			}
		}
	},
	methods: {
		addEntry() {
			let _self = this;
			let data = _.assign({}, this.local);
			data.user_id = _self.app.credentials.sub;
			axios({
					method: "post",
					url: INPUT_URL,
					data: data,
					headers: {
						Authorization: `Bearer ${auth.getToken()}`
					}
				})
				.then(function(response) {
					auth.setToken(response.headers["x-new-token"]);
					_self.local = _.assign({}, _self.app.temp.refueling);
					_self.app.messages.push(
						`This refuel has beeen registered.`
					);
					window.scrollTo(0, 0);
					_self.$v.local.$reset();
				})
				.catch(function(error) {
					auth.setToken(error.response.headers["x-new-token"]);
					try {
						auth.checkAuth(error);
					} catch (e) {}
				});
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
input
	display block
	border 1px solid #999
	padding .5em 1em
</style>



// WEBPACK FOOTER //
// Dashboard.vue?03d51b64